import { useMemo } from "react";

import QUERY_TAGS from "../search/queryTags";
import useQuery from "../search/useQuery";

import { fetchSupplierRating, fetchSupplierReviews } from "./detailService";
import { mapReview } from "./detailMappers";

export const REVIEWS_PAGE_SIZE = 10;

export const useSupplierRating = ({ supplierId, enabled = true }) => {
  const query = useQuery({
    key: supplierId && enabled ? `supplier-rating:${supplierId}` : null,
    tag: QUERY_TAGS.SUPPLIER_RATINGS,
    enabled: Boolean(supplierId) && enabled,
    fetcher: () => fetchSupplierRating(supplierId),
  });

  return {
    average: query.currentData?.average ?? null,
    total: query.currentData?.total ?? null,
    isLoading: Boolean(supplierId) && enabled && !query.isSuccess && !query.isError,
  };
};

export const useSupplierReviews = ({ supplierId, enabled = true }) => {
  const query = useQuery({
    key: supplierId && enabled ? `supplier-reviews:${supplierId}` : null,
    tag: QUERY_TAGS.SUPPLIER_RATINGS,
    enabled: Boolean(supplierId) && enabled,
    fetcher: () =>
      fetchSupplierReviews({ supplierId, page: 1, pageSize: REVIEWS_PAGE_SIZE }),
  });

  const reviews = useMemo(
    () =>
      (query.currentData?.rows || [])
        .map(mapReview)
        .filter((review) => review.active),
    [query.currentData]
  );

  return {
    reviews,
    total: query.currentData?.total ?? 0,
    isLoading: Boolean(supplierId) && enabled && !query.isSuccess && !query.isError,
  };
};
